import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';

import useEditPage from 'hooks/useEditPage';
const SalarypaymasterEditPage = (props) => {
		const app = useApp();
	// form validation schema
	const validationSchema = yup.object().shape({
		payname: yup.string().required().label($t('payname')),
		paytype: yup.string().required().label($t('paytype')),
		isactive: yup.string().required().label($t('isactive')),
		displayorder: yup.number().required().label($t('displayorder')),
		isrecurring: yup.string().required().label($t('isRecurring'))
	});
	// form default values
	const formDefaultValues = {
		payname: '', 
		paytype: '', 
		isactive: null, 
		displayorder: "0", 
		isrecurring: null, 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/salarypaymaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="SalarypaymasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editSalarypaymaster')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('payname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="payname"  onChange={formik.handleChange}  value={formik.values.payname}   label={$t('payname')} type="text" placeholder={$t('enterPayname')}        className={inputClassName(formik?.errors?.payname)} />
                                                <ErrorMessage name="payname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paytype')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="paytype"     optionLabel="label" optionValue="value" value={formik.values.paytype} onChange={formik.handleChange} options={app.menus.paytype} label={$t('paytype')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.paytype)}   />
                                                <ErrorMessage name="paytype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('isactive')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className="field-checkbox">
                                                    <label htmlFor="isactive" className="mr-2"><strong>True</strong></label>
                                                    <InputSwitch name="isactive" checked={formik.values.isactive} trueValue="true" falseValue="false" className={inputClassName(formik?.errors?.isactive)} onChange={formik.handleChange} />
                                                    <label htmlFor="isactive" className="ml-2"><strong>False</strong></label>
                                                </div>
                                                <ErrorMessage name="isactive" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('displayorder')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="displayorder"  onChange={formik.handleChange}  value={formik.values.displayorder}   label={$t('displayorder')} type="number" placeholder={$t('enterDisplayorder')}  min={0}  step="any"    className={inputClassName(formik?.errors?.displayorder)} />
                                                <ErrorMessage name="displayorder" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('isRecurring')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <div className="field-checkbox">
                                                    <label htmlFor="isrecurring" className="mr-2"><strong>True</strong></label>
                                                    <InputSwitch name="isrecurring" checked={formik.values.isrecurring} trueValue="true" falseValue="false" className={inputClassName(formik?.errors?.isrecurring)} onChange={formik.handleChange} />
                                                    <label htmlFor="isrecurring" className="ml-2"><strong>False</strong></label>
                                                </div>
                                                <ErrorMessage name="isrecurring" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
SalarypaymasterEditPage.defaultProps = {
	primaryKey: 'payid',
	pageName: 'salarypaymaster',
	apiPath: 'salarypaymaster/edit',
	routeName: 'salarypaymasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default SalarypaymasterEditPage;
